
import { mapToArray } from 'nucleus-widgets/utils/arrayToMap';
import formatAddress from './formatAddress';
import { transformHotelData } from './transformHotelData';

/*
 * Transforms the snapshot to make it easier to work with in the application.
 */
export default function transformTravelSnapshot(travelSnapshot, accountHotels) {
  return {
    hotelsData: {
      ...travelSnapshot.housingSetup,
      hotels: transformHotelData(mergeEventAndAccountHotel(travelSnapshot.housingSetup.hotels, accountHotels))
    },
    airData: {
      ...travelSnapshot.airSetup
    }
  };
}

// miles = 1, kilometers = 2
const DISTANCE_UNIT_MILES = 1;

export const DISTANCE_UNITS = {
  MILES: 'miles',
  KILOMETERS: 'kilometers'
};

/**
 * creates the hotel schema required by the hotelListWidget from hotels in travel and account snapshot
 * @param eventHotels hotel properties from travel snapshot
 * @param accountHotels hotel properties from account snapshot
 * @returns {Array|*}
 */
export function mergeEventAndAccountHotel(eventHotels, accountHotels) {
  return mapToArray(eventHotels).map(
    hotel => {
      const accountHotel = accountHotels[hotel.hotelId];
      return {
        ...accountHotel,
        ...hotel,
        address: formatAddress(accountHotel.address),
        websiteUrl: accountHotel.websiteLink,
        distanceUnit: hotel.distanceUnit === DISTANCE_UNIT_MILES ?
          DISTANCE_UNITS.MILES : DISTANCE_UNITS.KILOMETERS
      };
    }
  ).sort((one, two) => one.order - two.order);
}
